import { cn } from '@/utils/cn';
import { HTMLProps } from 'react';

export const TableCell = ({
    className,
    ...props
}: HTMLProps<HTMLTableCellElement>) => (
    <td className={cn('p-2 align-middle', className)} {...props} />
);
